<template>
  <div>
    <!-- 提示信息2 -->
    <alertStep
      :useDefault="false"
      :specialType="1"
      :specialRentCategory="rentDateInfo.rentCategory"
    />
    <!-- table -->
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      :span-method="arraySpanMethod"
      max-height="270">
      <el-table-column prop="fundType" label="收款项">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payMode" label="收款方式">
        <template slot-scope="scope">
          <span v-if="scope.row.isConfirm">{{ scope.row.payMode | enumerationFilter(paymentMethods) }}</span>
          <span class="tipRed" v-else>{{ scope.row.toast | filterToast(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column  prop="amount" label="收款金额">
        <template slot-scope="scope">
          <div v-if="!scope.row.isConfirm">
            <el-button
              @click.native.prevent="startConfigRow(scope.$index, scope.row)"
              type="text"
              size="small"
            >
              点击配置
            </el-button>
            <el-button
              v-if="isDeleteFn(scope.row)"
              @click.native.prevent="deleteRowConfig(scope.$index, scope.row.name)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </div>
          <div v-else>
            <!-- 固定方案 -->
            <template v-if="+scope.row.payPlanType === 0">
              <template v-if="+scope.row.amountType === 1"> <!-- 每期总金额 -->
                <span v-if="+scope.row.payMode === 6"> <!-- 一次性 -->
                  {{ scope.row.amount | addUnit(scope.row)}}
                </span>
                <span v-else>
                  {{ `${'每期总金额 ' + formatNumberWithCommas(scope.row.amount) + ' 元'}` }}
                </span>
              </template>
              <template v-else-if="+scope.row.amountType === 2"> <!-- 日租金xxx元 x 每期自然天数 -->
                {{ `${'日租金 ' + formatNumberWithCommas(scope.row.amount) + ' 元' + ' x 每期自然天数'}` }}
              </template>
              <template v-else>
                {{ scope.row.amount | addUnit(scope.row)}}
              </template>
            </template>
            <!-- 阶梯方案 -->
            <template v-if="+scope.row.payPlanType === 1">
              <template v-if="+scope.row.amountType === 1"> <!-- 每期总金额 -->
                {{ scope.row.piecewiseList | piecewiseFormate}}
              </template>
              <template v-if="+scope.row.amountType === 2"> <!-- 日租金xxx元 x 每期自然天数 -->
                {{ scope.row.piecewiseList | dailyPiecewiseFormate}}
              </template>
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="isConfirm" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.isConfirm"
            @click.native.prevent="modificationRowConfig(scope.$index, scope.row)"
            type="text"
            size="small"
          >
            修改
          </el-button>
          <el-button
            v-if="isDeleteFn(scope.row)"
            @click.native.prevent="deleteRowConfig(scope.$index, scope.row.name)"
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- button -->
    <div class="planSetup-setupBox-operation">
      <el-select v-model="addFundType" placeholder="请选择">
        <el-option
          v-for="item in rentOrderFeeFilterList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
      <el-button type="primary" @click="addPaymentPlan">新增收款项</el-button>
    </div>
    <PaymentPlanPopup
      v-model="popupShow"
      :configPaymentPlan="configPaymentPlanData"
      :isAddScheme="true"
      :configDisabled="false"
      :rentCategory="rentDateInfo.rentCategory"
      @getParams="getParams"
    />
  </div>
</template>
<script>
import PaymentPlanPopup from '@/components/PaymentPlanPopup/index.vue'
import alertStep from '@/components/rentCalculateConfig/alertStep.vue'
import orderConfigFn from '@/pages/orders/config/index.js'
import { CATEGORY_CODE_MAP, CATEGORY_FEE_MAP, FEE_CODE_MAP, ADVANCEPAYMENT_CODE_MAP, PAYMODE_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import selectOption from '@/store/dict/selectOptionDict'
import { formatNumberWithCommas } from '@/utils'
import _cloneDeep from 'lodash/cloneDeep'
import { isNewOverdue } from '@/pages/utils/overdue'
import { mapState } from 'vuex'

export default {
  name: 'SchemeRentLeasePlanInfo',
  components: {
    alertStep,
    PaymentPlanPopup,
  },
  props: {
    rentDateInfo: { // 包含合同起止时间、租期、赠送天数、前置免租天数、类别
      type: Object,
      default: () => ({
        rentCategory: 1, // 类别 - 默认租车
        rentPeriod: null, // 租赁周期
        presentDays: null, // 赠送天数
        preFreeRentDays: null, // 前置免租天数
        rentPeriodType: null,
        payMode: '', // 收款方式
      }),
    },
    defaultTableData: { // 支付计划数据
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    const { m_weekList } = orderConfigFn.call(this)
    return {
      formatNumberWithCommas,
      m_weekList: this.formatEnumeration(m_weekList),
      selectOption,
      addFundType: '',
      tableData: [],
      tableLoading: false,
      rentOrderFeeFilterList: [],
      // 弹窗相关
      popupShow: false,
      configPaymentPlanData: {
        formData: {},
      },
    }
  },
  filters: {
    // 收款项显示中文
    enumerationFilter(val, list) {
      const name = (list && list.find((item) => {
        return Number(item.code) === Number(val)
      })?.name) || '--'
      return name
    },
    // 增加单位
    addUnit(val, rowData) {
      if (isNewOverdue(rowData)) {
        return `未付租金*${rowData.lateFeeProportion}%/日`
      } else if (val === 0 || val) {
        return `${formatNumberWithCommas(val)} 元`
      } else {
        return '--'
      }
    },
    // 固定金额阶梯
    piecewiseFormate(val) {
      const spliceText = val.reduce((total, item) => {
        total = `${total + item.startMonth}-${item.endMonth}月 ${formatNumberWithCommas(item.amount)} 元；`
        return total
      }, '')
      return spliceText
    },
    // 日租金模式阶梯
    dailyPiecewiseFormate(val) {
      const spliceText = val.reduce((total, item) => {
        total = `${total + item.startMonth}-${item.endMonth}月 日租金 ${formatNumberWithCommas(item.amount)} 元 x 当期自然天数；`
        return total
      }, '')
      return spliceText
    },
    filterToast(val, rowData) {
      const text = `${val}请点击配置${rowData.name}规则`
      return text
    },
  },
  computed: {
    ...mapState({
      paymentMethods: (state) => state.global.paymentMethods, // 收款方式
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
  },
  watch: {
    'rentDateInfo.rentCategory': {
      handler() {
        this.queryFeeList()
      },
    },
    defaultTableData: {
      handler(val) {
        if (val.length) {
          this.tableData = _cloneDeep(val)
        }
      },
      deep: true,
    },
    tableData: {
      handler() {
        this.queryFeeList()
      },
      deep: true,
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('getPaymentMethods', { type: 'payMode' }) // 获取收款方式
    },
    // 合并列
    arraySpanMethod({ row, columnIndex }) {
      if (row.isConfirm === false) {
        if (columnIndex === 1) {
          return [1, 2]
        }
        return [1, 1]
      }
    },
    // 请求费项list
    queryFeeList() {
      if (!this.rentDateInfo.rentCategory) {
        return
      }
      this.tableLoading = true
      const someFeeList = this[CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)]]
      if (!someFeeList || !someFeeList.length) {
        // 根据【类别】获取不同类别对应的费项
        this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)] }).then((res) => {
          this.tableLoading = false
          this.setSelectList(res.data)
        }).catch(() => {
          this.tableLoading = false
          this.$set(this, 'rentOrderFeeFilterList', [])
        })
      } else {
        this.tableLoading = false
        this.setSelectList(someFeeList)
      }
    },
    // 设置新增收款项list
    setSelectList(feeList) {
      if (Number(this.rentDateInfo.rentCategory) !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为【租车】和【司机合作模式】，新增费项的list为过滤掉必填项
        this.$set(this, 'rentOrderFeeFilterList', feeList.filter((it) => !it.required))
      } else { // 类别为【以租代购】
        // 新增费项的list为过滤掉table中已经有的费项（首付款, 租金, 全款）
        const filterFeeCodes = [FEE_CODE_MAP.SHOU_FU_KUAN, FEE_CODE_MAP.ZU_JIN, FEE_CODE_MAP.QUAN_KUAN] // 首付款, 租金, 全款
        filterFeeCodes.forEach((feeCode) => {
          if (this.tableData.some((i) => Number(i.fundType) === feeCode)) {
            feeList = feeList.filter((it) => Number(it.code) !== feeCode)
          }
        })
        this.$set(this, 'rentOrderFeeFilterList', feeList)
      }
    },
    // 校验必填费项
    validRequiredFee() {
      if (!this.tableData.length) {
        return false
      } else if (!this.tableData.some((i) => i.required)) {
        return false
      } else {
        return true
      }
    },
    // 已添加的是否可删除 - 【以租代购】互斥逻辑
    isDeleteFn(rowData) {
      if (this.rentDateInfo.rentCategory !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 除类别为 【已租代购】，其他类别添加的收款项中，非必填字段可删除
        return (!rowData.required)
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) { // 24-首付款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.ZU_JIN) { // 1-租金
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.QUAN_KUAN) { // 15-全款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN))
      } else {
        return (!rowData.required)
      }
    },
    // 点击配置
    startConfigRow($index, rowData) {
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      const formData = {
        ...rowData,
        rentPeriod: this.rentDateInfo.rentPeriod,
        rentPeriodType: this.rentDateInfo.rentPeriodType,
        preFreeRentDays: this.rentDateInfo.preFreeRentDays,
      }
      this.configPaymentPlanData.formData = formData
      this.popupShow = true
    },
    // 新增收款项
    addPaymentPlan() {
      // 新增收款项之前的校验
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      if (!this.addFundType) return
      const hasSomeFundType = this.tableData.find((i) => Number(i.fundType) === Number(this.addFundType))
      if (hasSomeFundType) {
        this.$message.error(`收款项”${hasSomeFundType.name}”已在支付计划中，请勿重复添加`)
        return
      }
      const formData = {
        fundType: Number(this.addFundType),
        rentPeriod: this.rentDateInfo.rentPeriod,
        rentPeriodType: this.rentDateInfo.rentPeriodType,
        preFreeRentDays: this.rentDateInfo.preFreeRentDays,
      }
      // 如果新增的是滞纳金，则将滞纳金标识设置为1，代表新的滞纳金
      if (this.addFundType === FEE_CODE_MAP.ZHI_NA_JIN) {
        formData.lateFeeOpen = 1
      }
      this.configPaymentPlanData.formData = formData
      this.popupShow = true
      this.addFundType = null // 添加完后置空
    },
    // 修改配置
    modificationRowConfig($index, rowData) {
      const modifiedFeeItem = this.tableData.some((i) => Number(i.fundType) === Number(rowData.fundType))
      if (!modifiedFeeItem) {
        console.error('未在table数据中找到修改费项，请检查tableData数据是否正常')
        return false
      }
      const formData = {
        ...rowData,
        rentPeriod: this.rentDateInfo.rentPeriod,
        rentPeriodType: this.rentDateInfo.rentPeriodType,
        preFreeRentDays: this.rentDateInfo.preFreeRentDays,
      }
      this.configPaymentPlanData.formData = formData
      this.popupShow = true
    },
    // 删除配置
    deleteRowConfig($index, feeName) {
      this.$confirm(`收款项${feeName}及相关款项配置将从支付计划中删除，确定?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.splice($index, 1)
      }).catch(() => null)
    },
    // 新增收款项或配置支付计划之前的校验
    beforeValid(messageFlag) {
      const messageMap = {
        add: '请先填写“预计租赁周期”',
        edit: '请先填写“预计租赁周期”',
      }
      if (!this.rentDateInfo.rentPeriod || Number(this.rentDateInfo.rentPeriod) === 0) {
        this.$message.error(messageMap[messageFlag])
        // 此时需要锚点到【预计租赁周期】的位置上去
        this.$emit('autoAnchor', false)
        return false
      } else {
        return true
      }
    },
    // 表单校验，若通过校验，返回table数据，若未通过，返回false
    getFormData() {
      // 表格部分的收费项校验
      const requiredValidRes = this.validRequiredFee()
      if (!requiredValidRes) {
        this.$message.error('费项配置无必填项！请检查')
        return false
      }
      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为以租代购
        // 如果有「全款」费项，校验 是否有「首付款」或「租金」或「尾款」，如果有则阻断提交
        if (this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) { // 15-全款
          if (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN || Number(i.fundType) === FEE_CODE_MAP.WEI_KUAN)) { // 24-首付款 1-租金 25-尾款
            this.$message.error('签约时，全款 和 首付款/租金/尾款 不能同时收取，请检查修复后重新提交')
            return false
          }
        } else if (!this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) || !this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN)) { // 1-租金 24-首付款
          // 如果没有「全款」，校验 「首付款」和「租金」 为必填项，都必须填全
          this.$message.error('首付款和租金为必填项，都必须填全')
          return false
        }
      }
      // 添加的费项都配置完成才能返回true
      const tableDataHasNoConfig = this.tableData.some((i) => i.isConfirm === false)
      if (tableDataHasNoConfig) {
        const noConfigFeeNames = this.tableData.reduce((total, item) => {
          if (!item.isConfirm) {
            total = total.concat([`【${item.name}】`])
          }
          return total
        }, [])
        this.$message.error(`请将${noConfigFeeNames.toString()}费项配置完成`)
        return false
      }
      return this.tableData
    },
    disposeOverdueRowData(item) {
      // 发车前收款 为 发车前不收
      item.advancePayment = ADVANCEPAYMENT_CODE_MAP.NOT_ACCEPT
      // 收款方式 为 一次性
      item.payMode = PAYMODE_CODE_MAP.DISPOSABLE
      item.lastPeriodRule = null
      item.payDate = null
      item.payDay = null
      item.payPost = null
    },
    // 点击弹窗的确定，获取配置的表单
    getParams(value) {
      if (this.tableData.some((i) => Number(i.fundType) === Number(value.formData.fundType))) { // 费项列表中已添加
        const newTableData = this.tableData.map((item) => {
          if (Number(item.fundType) === Number(value.formData.fundType)) {
            const nite = Object.assign({}, item, value.formData)
            nite.isConfirm = true
            // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (修改时)
            if (isNewOverdue(value.formData)) {
              this.disposeOverdueRowData(nite)
            }
            return nite
          } else {
            return item
          }
        })
        this.$set(this, 'tableData', newTableData)
      } else { // 费项类表中未添加
        const fee = this[CATEGORY_FEE_MAP[this.rentDateInfo.rentCategory]].find((i) => Number(i.code) === Number(value.formData.fundType))
        const addFeeItem = {
          ...value.formData,
          fundType: fee.code,
          name: fee.name,
          required: fee.required,
          toast: fee.toast,
        }
        addFeeItem.isConfirm = true
        // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (添加时)
        if (isNewOverdue(value.formData)) {
          this.disposeOverdueRowData(addFeeItem)
        }
        this.tableData.push(addFeeItem)
      }
    },
    getPayDate(rowData) {
      if (isNewOverdue(rowData)) {
        return '--'
      } else if (Number(rowData.payPost) === 10) {
        return '自定义'
      } else {
        return '订单收款起始日'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.planSetup-setupBox-operation {
  margin-top: 20px;
  margin-bottom: 20px;
}
.tipRed{
  color: #FF5964;
}
</style>
